import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';
import { useSelector } from 'react-redux';

export type CompensationIntentType = {
  id: string;
  label: string;
  onClick: () => void;
  visible: () => boolean;
  value: {
    team?: {
      directReports?: IntentValuesType;
      allReports?: IntentValuesType;
    };
    company?: IntentValuesType;
  };
  category: 'Manage' | 'Analyze' | 'Configure';
  isDefault?: boolean;
};

const initialState: {
  selectedIntent: null | CompensationIntentType;
} = {
  selectedIntent: null,
};

export const CompensationIntentSlice = createSlice({
  name: 'compensationIntent',
  initialState,
  reducers: {
    setSelectedCompensationIntent: (state, action: PayloadAction<CompensationIntentType>) => {
      const newState = { ...state };
      newState.selectedIntent = action.payload;
      return newState;
    },
  },
});

export const { setSelectedCompensationIntent } = CompensationIntentSlice.actions;

export default CompensationIntentSlice.reducer;

export const useSelectedCompensationIntent = () =>
  useSelector(
    (state: { compensationIntent: { selectedIntent: CompensationIntentType | null } }) => state.compensationIntent
  );
